const Joi = require('joi');

exports.buildUserInputsSchema = ({
    maxFirstAndLastNameLength = 30,
    maxBio = 160,
    maxPronounsLength = 30,
    maxEthnicityLength = 150
} = {}) => {

    return Joi.object({
        firstName: Joi.string()
            .allow('', null)
            .max(maxFirstAndLastNameLength)
            .messages({
                'string.max': `First name must be ${maxFirstAndLastNameLength} characters or less`
            }),
        lastName: Joi.string()
            .allow('', null)
            .max(maxFirstAndLastNameLength)
            .messages({
                'string.max': `Last name must be ${maxFirstAndLastNameLength} characters or less`
            }),
        bio: Joi.string()
            .allow('', null)
            .max(maxBio)
            .messages({
                'string.max': `Bio must be ${maxBio} characters or less`
            }),
        pronouns: Joi.string()
            .allow('', null)
            .max(maxPronounsLength)
            .messages({
                'string.max': `Pronouns must be ${maxPronounsLength} characters or less`
            }),
        ethnicityText: Joi.string()
            .allow('', null)
            .max(maxEthnicityLength)
            .messages({
                'string.max': `Ethnicity must be ${maxEthnicityLength} characters or less`
            })
    }).unknown(true);
};
